(function () {
    "use strict";

    var NoteSelectorControl = Solovis.defineClass(
        "Solovis.InvDataSelectors.NoteSelectorControl",
        Solovis.UI.BaseControl,
        function (options) {
            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
        });


    NoteSelectorControl.prototype.doInit = function () {
    };

    NoteSelectorControl.prototype.doRender = function () {
        var self = this;

        $("<span>").text("Note ID").appendTo(this.container)
            .css("margin-right", "5px");

        this.idInput = $("<input>").attr("type", "text").appendTo(this.container)
            .css("margin-right", "5px");

        var findButton = $("<button>").text("Find").appendTo(this.container);

        findButton.click(function () {
            var noteId = parseInt(self.idInput.val());

            Solovis.Rpc.invoke("~/Selectors/NoteSelector/GetNoteData", { noteId: noteId },
                function (response, success) {
                    if (success) {
                        var noteData = response.result;
                        self.selectionCallback(noteData);
                    }
                });
        });

        // Trigger cancel when escape is pressed.
        $(this.idInput).keyup(function (e) {
            if (e.keyCode == 27) {
                // Escape was pressed.
                if (self.cancelCallback) {
                    self.cancelCallback();
                }
            }
        });
    };

    NoteSelectorControl.prototype.focus = function () {
        if (this.idInput) {
            this.idInput.focus();
        }
    };
})();